import { Expose } from 'class-transformer';

import { ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

export class SnTipNote extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public note: string;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public tip: string;

  @ExposeRawData()
  public integrationMeta;

  constructor(data: any) {
    super();
    this.fromJSON(data);
  }
}
